import { Button, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { KYC_REGISTRATION_COMPLETED_STATUS } from '@features/eInvoicing/constants'
import { getEInvoicesUrl } from '@features/eInvoicing/utils'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSegment } from '../../../../hooks'
import { useEInvoicingIntegration } from '../../../../hooks/useEInvoicingIntegration'
import { Widget } from '../../elements/Widget'
import * as Styled from './styles'

export const CegidEInvoices = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { organization } = useUserOrganization()
  const { kycStatus, isEInvoicingEnabled } = useEInvoicingIntegration(organization)

  const bannerTitle =
    kycStatus === 'KYC_CREATED'
      ? t('dashboard.widget.cegid.onboarding.pending.reception.title')
      : t('dashboard.widget.cegid.onboarding.preregistered.reception.title')
  const bannerDescription =
    kycStatus === 'KYC_CREATED'
      ? t('dashboard.widget.cegid.onboarding.pending.reception.description')
      : t('dashboard.widget.cegid.onboarding.preregistered.reception.description')
  const hideBanner =
    KYC_REGISTRATION_COMPLETED_STATUS.includes(kycStatus) || !isEInvoicingEnabled || !organization?.isCegid

  const handleCTAClick = useCallback(() => {
    track('xxx - e-invoicing: Clicked "See e-invoices" (Client)')
  }, [track])

  useEffect(() => {
    if (hideBanner) {
      return
    }
    track('xxx - e-invoicing: Viewed "See e-invoices" (Client)', {
      eInvoicingBannerSource: 'dashboard',
    })
  }, [hideBanner, track])

  return (
    <Widget>
      <Styled.CegidEInvoicesWidgetWrapper>
        <Styled.ContentWrapper>
          <Styled.Header>
            <Text variant="h1">{bannerTitle}</Text>
            <Space />
            <Styled.DescriptionWrapper>{bannerDescription}</Styled.DescriptionWrapper>
          </Styled.Header>
          <Button to={getEInvoicesUrl(organization)} onClick={handleCTAClick}>
            {t('dashboard.banner.cegid.e_invoicing.cta')}
          </Button>
        </Styled.ContentWrapper>
      </Styled.CegidEInvoicesWidgetWrapper>
    </Widget>
  )
}
